import Api from 'App/api'

export const requestAmenities = Api.get({
  controller: 'amenities',
  action: 'listWithSettings',
})

export const requestUpcomingAmenities = Api.get({
  controller: 'amenities',
  action: 'listReservations',
})

export const deleteReservation = Api.post({
  controller: 'amenities',
  action: 'cancelReservation',
})

export const saveAmenityReservation = Api.post({
  controller: 'amenities',
  action: 'save',
})

export const saveInternationalAmenityReservation = Api.post({
  controller: 'amenities',
  action: 'saveInternationalAmenityReservation',
})

export const getReservationAmount = Api.post({
  controller: 'amenities',
  action: 'getReservationAmount',
})

export const downloadAmenityDoc = Api.get({
  controller: 'amenities',
  action: 'loadAmenityDocument',
})

export const getAmenityData = requestAmenities
